import AdminRoleSelect from './adminRoleSelect.container';

export default AdminRoleSelect;
